import { css, styled } from "styled-components";

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.64);
  z-index: 1000;
`;

export const ContentsWrapper = styled.div`
  display: flex;
  gap: 1.2rem;
  width: 68rem;
  height: auto;
  flex-direction: column;
  border-radius: 0.8rem;
  background: var(--Color-Common-Bg-Primary, #ffffff);
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.16), 0 0 8px 0 rgba(0, 0, 0, 0.12);
  overflow: hidden;
  padding: 1.2rem 2rem 2rem 2rem;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
`;

export const Title = styled.h2`
  color: var(--Color-Common-Text-Primary, #2a2f37);
  font-family: var(--font-pretendard);
  font-size: var(--text-body-size-lg, 1.6rem);
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 2.4rem */
  letter-spacing: -0.008rem;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 0.4rem;
  padding: 0;
`;

export const SearchAndValueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  flex: 1;
`;

export const SearchIconWrapper = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: #a8adb5;
  transition: color 0.15s;
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  height: 3.2rem;
  width: 100%;
  padding: 0 0 0 0.8rem;
  border: 1px solid #b1b8c4;
  border-radius: 0.4rem;
  background: #fff;
  flex-shrink: 0;
  transition: border-color 0.15s;

  &:focus-within {
    ${SearchIconWrapper} {
      path {
        fill: #0198e9;
      }
    }
  }
`;

export const SearchClearButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.8rem;
  height: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  border-left: 1px solid #e5e7eb;

  &:hover svg path {
    fill: #2a2f37;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-family: var(--font-pretendard);
  font-size: 1.4rem;
  color: #2a2f37;
  font-weight: 500;

  &::placeholder {
    color: #a8adb5;
  }
`;

export const ColumnsWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

export const ColumnDivider = styled.div`
  width: 8px;
  background: transparent;
  flex-shrink: 0;
`;

export const ColumnHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.4rem 0rem;
  flex-shrink: 0;
`;

export const ColumnTitle = styled.span`
  color: var(--Color-Common-Text-Primary, #2a2f37);
  font-family: var(--font-pretendard);
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 2.1rem */
  letter-spacing: -0.007rem;
`;

export const ClearAllButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.2rem;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 1.2rem;
  font-weight: 500;
  color: #e53e06;
  padding: 0.2rem 0.4rem;

  &:hover {
    color: #b83205;
    svg > path {
      fill: #b83205;
    }
  }
  &:active {
    color: #8b2504;
    svg > path {
      fill: #8b2504;
    }
  }

  &:disabled {
    color: #96a1b0;
    cursor: not-allowed;
    svg > path {
      fill: #96a1b0;
    }
  }
`;

export const TreeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 60vh;
  max-height: 68.1rem;
`;

export const TreeList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  overflow-y: scroll;
  padding: 1.2rem 0.8rem;
  gap: 0.8rem;
  border-radius: 0.4rem;
  background: var(--Color-Common-Bg-Secondary, #f0f2f4);

  &::-webkit-scrollbar {
    width: 0.6rem;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 0.3rem;
  }
`;

export const TreeItem = styled.div<{ $depth: number }>`
  display: flex;
  align-items: flex-start;
  gap: 0.2rem;
  padding: 0rem 0.4rem;
  height: fit-content;
  padding-left: ${({ $depth }) => 0.4 + $depth * 2}rem;
  cursor: default;
`;

export const ExpandButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;
  flex-shrink: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  color: #7c899c;
  border-radius: 0.2rem;
  outline: none;
`;

export const ExpandSpacer = styled.span`
  width: 2.4rem;
  height: 2.4rem;
  flex-shrink: 0;
`;

export const ArrowIcon = styled.span<{ $expanded: boolean }>`
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;

  ${({ $expanded }) =>
    $expanded
      ? css`
          border-width: 5px 4px 0 4px;
          border-color: #7c899c transparent transparent transparent;
          margin-top: 1px;
        `
      : css`
          border-width: 4px 0 4px 5px;
          border-color: transparent transparent transparent #7c899c;
          margin-left: 2px;
        `}
`;

export const CheckboxEl = styled.div<{
  $state: "checked" | "indeterminate" | "unchecked";
}>`
  margin-top: 0.4rem;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 0.2rem;
  flex-shrink: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.1s, border-color 0.1s;

  ${({ $state }) => {
    if ($state === "unchecked") {
      return css`
        border: 1.5px solid #b1b8c4;
        background: #ffffff;
      `;
    }
    return css`
      background: #1baefe;
      border: 1.5px solid #1baefe;
    `;
  }}

  ${({ $state }) =>
    $state === "checked" &&
    css`
      &::after {
        content: "";
        width: 0.45rem;
        height: 0.75rem;
        border: 2px solid #ffffff;
        border-top: none;
        border-left: none;
        transform: rotate(45deg) translate(-1px, -1px);
      }
    `}

  ${({ $state }) =>
    $state === "indeterminate" &&
    css`
      border: 1.5px solid #0198e9;
      background: #e5f7ff;
      &::after {
        content: "";
        width: 0.8rem;
        height: 0.15rem;
        background: #0198e9;
        border-radius: 1px;
      }
    `}
`;

export const ItemLabel = styled.span`
  padding: 0.4rem 0.2rem;
  color: var(--Color-Common-Text-Primary, #2a2f37);
  font-family: var(--font-pretendard);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  flex: 1;
  cursor: pointer;

  &:hover {
    color: #0f172a;
  }
`;

export const ItemCount = styled.span`
  padding: 0.4rem 0rem;
  color: var(--Color-Common-Text-Tertiary, #7c899c);
  text-align: center;
  font-family: var(--font-pretendard);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  min-width: 1.6rem;
  text-align: right;
`;

export const RowDivider = styled.div`
  width: 100%;
  height: 1px;
  min-height: 1px;
  background: #e5e7eb;
`;
export const GroupsLabel = styled.div`
  color: var(--Color-Common-Text-Tertiary, #7c899c);
  font-family: var(--font-pretendard);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 130%; /* 1.56rem */
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
`;

export const CountText = styled.span`
  color: var(--Color-Common-Text-Tertiary, #7c899c);
  font-family: var(--font-pretendard);
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 2.1rem */
  letter-spacing: -0.007rem;
`;

export const FooterButtons = styled.div`
  display: flex;
  gap: 1.6rem;
`;

export const CancelButton = styled.button`
  width: 12rem;
  padding: 0.8rem 1.6rem;
  color: var(--Color-Common-Text-Interactive-Secondary, #515c6c);
  text-align: center;
  font-family: var(--font-pretendard);
  font-size: var(--text-body-size-md, 1.4rem);
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 1.96rem */
  background: #ffffff;
  border: 1px solid #b1b8c4;
  border-radius: 0.4rem;
  cursor: pointer;

  &:hover {
    color: #3d4551;
    border-radius: var(--Border-Radius-4, 0.4rem);
    border: 1px solid
      var(--Color-Common-Border-Interactive-Secondary-Hovered, #96a1b0);
    background: var(--Color-Common-Bg-Interactive-Secondary-Hovered, #f0f2f4);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 0 2px 0 rgba(0, 0, 0, 0.12);
  }
  &:active {
    color: #2a2f37;
    border-radius: var(--Border-Radius-4, 0.4rem);
    border: 1px solid
      var(--Color-Common-Border-Interactive-Secondary-Pressed, #7c899c);
    background: var(--Color-Common-Bg-Interactive-Secondary-Pressed, #e5e7eb);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08) inset,
      0 0 2px 0 rgba(0, 0, 0, 0.06) inset;
  }
`;

export const ApplyButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.2rem;
  justify-content: center;
  width: 12rem;
  padding: 0.8rem 1.6rem;
  color: #fff;
  text-align: center;
  font-family: var(--font-pretendard);
  font-size: var(--text-body-size-md, 1.4rem);
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 1.96rem */
  background: #ffffff;
  border: 1px solid #1baefe;
  background-color: #1baefe;
  border-radius: 0.4rem;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-radius: var(--Border-Radius-4, 0.4rem);
    background: var(--Color-Common-Bg-Interactive-Primary-Hovered, #0198e9);
    border: 1px solid
      var(--Color-Common-Border-Interactive-Primary-Hovered, #0198e9);

    /* Elevation/Light/Shadow4 */
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 0 2px 0 rgba(0, 0, 0, 0.12);
  }
  &:hover:not(:disabled) {
    border-radius: var(--Border-Radius-4, 0.4rem);
    background: var(--Color-Common-Bg-Interactive-Primary-Pressed, #017abc);
    border: 1px solid
      var(--Color-Common-Border-Interactive-Primary-Pressed, #017abc);

    /* Pushed/Light/Inner Shadow4 */
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08) inset,
      0 0 2px 0 rgba(0, 0, 0, 0.06) inset;
  }

  &:disabled {
    color: #96a1b0;
    background: #cbd0d8;
    border: 1px solid #cbd0d8;
    cursor: not-allowed;

    svg > path {
      fill: #96a1b0;
    }
  }
`;
